<template>
  <div id="app" class="gray-bg">
    <keep-alive include="dataTypein">
      <router-view />
    </keep-alive>

  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  /* min-width: 960px; */
}

.page {
  padding: 20px 55px;
}

.gray-bg {
  background-color: #f3f3f4;
  min-height: 100vh;
}

@keyframes scroll {
  0% {
    overflow-x: visible;
    transform: translateX(0);
  }

  50% {
    overflow-x: visible;
    transform: translateX(-400px);
  }

  100% {
    overflow-x: scroll;
    transform: translateX(0);
  }
}

@media screen and (max-width: 720px) {
  .page {
    padding: 20px 10px;
  }
}

.wrapper-content {
  background: #fff;
  padding: 0;
}

.ibox-title {
  -moz-border-bottom-colors: none;
  -moz-border-left-colors: none;
  -moz-border-right-colors: none;
  -moz-border-top-colors: none;
  background-color: #fff;
  border-color: #e7eaec;
  -webkit-border-image: none;
  -o-border-image: none;
  border-image: none;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-title h5 {
  display: block;
  font-size: 20px;
  margin: 0 0 7px;
  padding: 0;
  text-overflow: ellipsis;
  color: #33434b;
  font-weight: bold;
}

.wrapper-content .box {
  padding: 20px;
  border-top: 1px solid #a9afb5;
}

table th,
table td {
  color: #33434b !important;
}

.row.justify-content-md-center {
  margin-left: 0;
  margin-right: 0;
}

.cursor:hover {
  cursor: pointer;
}

.errInfo {
  color: red;
  font-size: 13px;
}

.no-result {
  text-align: center;
  color: #333;
  padding: 20px 0;
  width: 100%;
}

td>a {
  cursor: pointer;
}

.container {
  max-width: 1140px !important;
  min-width: 1140px !important;
  width: 1140px !important;
}

.alignCenter {
  align-items: center;
  display: flex;
}

label {
  text-align: right;
  padding-right: 10px !important;
}

.table-content {
  /* overflow-x: auto; */
}

.table thead th {
  border-bottom: 2px solid #a9afb5 !important;
}

.table td,
.table th {
  border-top: 1px solid #a9afb5 !important;
  white-space: nowrap;
}

.table {
  border: 1px solid #a9afb5 !important;
}

.border {
  border: 1px solid #a9afb5 !important;
}

.form-control,
.border-bottom {
  border-color: #a9afb5 !important;
}

@media only screen and (max-width: 750px) {
  .container {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .wrapper-content .box {
    padding: 20px 10px !important;
  }

  .pagination {
    flex-wrap: wrap !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue